import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import routes from "./App";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <App />
  <>
    <AuthProvider>
      <RouterProvider router={routes} />
    </AuthProvider>
    <ToastContainer />
  </>

  // <React.StrictMode>
  // </React.StrictMode>
);
